export default {
  confirmDelete: 'Delete "{0}"?',
  emptyMessage: 'No {0} available.',
  uploadButtonLabel: 'Upload {0}',
  files: 'files',
};
